export const updateSFTPProcessing = `mutation UpdateSFTPProcessing($input: UpdateSFTPProcessingInput!) {
    updateSFTPProcessing(input: $input) {
        id
        status
    }
  }
  `;